import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ displayState }) => css`
    color: ${displayState.color ?? window?.settings?.primary_color ?? '#1DBD6B'};
  `}
`;

export default Wrapper(template);
